export default __webpack_public_path__ + "static/media/fast-forward-asc.e80b3893.png";